"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardsCheckingBundleAskVariant = exports.REWARDS_DEPOSIT_BUNDLE_LIVE_STATUSES = exports.REWARDS_DEPOSIT_BUNDLE_AGREED_STATUSES = exports.REWARDS_DEPOSIT_BUNDLE_AWAITING_FUNDING_STATUSES = exports.REWARDS_DEPOSIT_BUNDLE_UNFINISHED_STATUSES = exports.RewardsDepositBundleEnrollmentStatus = void 0;
/**
 * Shared Rewards + Checking cashback enrollment, including the Home Checking opt-in.
 * Bundle membership and the committed decision are tracked per card loan application.
 * Checking opening requires accepted consent and a ready credit account; rewards require qualifying settled funding.
 */
/**
 * Lifecycle of a Rewards + Deposit bundle enrollment. One meaning per status, shared by both products that use it:
 * the Rewards Card bundle and the Home Card Checking-cashback opt-in.
 * - started: the offer is presented and the customer has not decided
 * - accepted: the customer agreed to the Checking offer; Checking is not open yet
 * - pendingFunding: Checking is open and linked; the enrollment is awaiting the qualifying deposit that unlocks the boost
 * - active: the qualifying funding requirement was met and the bundle boost is live
 * - suspended: the maintained-balance requirement lapsed; reverted to the standard rewards tier
 * - declined: the customer declined the Checking offer
 * - expired: the funding window elapsed without qualifying, or the enrollment was otherwise terminated
 *
 * Historical rows can predate the decision timestamps: the status alone is not proof of when consent happened.
 */
var RewardsDepositBundleEnrollmentStatus;
(function (RewardsDepositBundleEnrollmentStatus) {
    RewardsDepositBundleEnrollmentStatus["started"] = "started";
    RewardsDepositBundleEnrollmentStatus["accepted"] = "accepted";
    RewardsDepositBundleEnrollmentStatus["pendingFunding"] = "pendingFunding";
    RewardsDepositBundleEnrollmentStatus["active"] = "active";
    RewardsDepositBundleEnrollmentStatus["suspended"] = "suspended";
    RewardsDepositBundleEnrollmentStatus["declined"] = "declined";
    RewardsDepositBundleEnrollmentStatus["expired"] = "expired";
})(RewardsDepositBundleEnrollmentStatus || (exports.RewardsDepositBundleEnrollmentStatus = RewardsDepositBundleEnrollmentStatus = {}));
/**
 * Status groups, exported next to the enum so every reader means the same set instead of re-listing statuses.
 */
/** Enrollment still has an outstanding Checking or funding step. */
exports.REWARDS_DEPOSIT_BUNDLE_UNFINISHED_STATUSES = [
    RewardsDepositBundleEnrollmentStatus.started,
    RewardsDepositBundleEnrollmentStatus.accepted,
    RewardsDepositBundleEnrollmentStatus.pendingFunding,
];
/** Agreed, but the boost is not live yet: Checking opening or qualifying funding is still outstanding. */
exports.REWARDS_DEPOSIT_BUNDLE_AWAITING_FUNDING_STATUSES = [
    RewardsDepositBundleEnrollmentStatus.accepted,
    RewardsDepositBundleEnrollmentStatus.pendingFunding,
];
/** The customer agreed to the offer, whether or not the bundle is live. */
exports.REWARDS_DEPOSIT_BUNDLE_AGREED_STATUSES = [
    RewardsDepositBundleEnrollmentStatus.accepted,
    RewardsDepositBundleEnrollmentStatus.pendingFunding,
    RewardsDepositBundleEnrollmentStatus.active,
    RewardsDepositBundleEnrollmentStatus.suspended,
    RewardsDepositBundleEnrollmentStatus.expired,
];
/** Checking is open and linked, and the enrollment has not been reverted or terminated: the bundle is still live. */
exports.REWARDS_DEPOSIT_BUNDLE_LIVE_STATUSES = [RewardsDepositBundleEnrollmentStatus.pendingFunding, RewardsDepositBundleEnrollmentStatus.active];
var RewardsCheckingBundleAskVariant;
(function (RewardsCheckingBundleAskVariant) {
    RewardsCheckingBundleAskVariant["openAccount"] = "openAccount";
    RewardsCheckingBundleAskVariant["fundAccount"] = "fundAccount";
})(RewardsCheckingBundleAskVariant || (exports.RewardsCheckingBundleAskVariant = RewardsCheckingBundleAskVariant = {}));
